import {
  trackSigninHcaptchaUserWaitTiming,
  trackSigninHcaptchaUserWaitTimingTraceDataRequested,
  trackSigninHcaptchaUserWaitTimingTraceDataRetrieved,
  trackSigninHcaptchaUserWaitTimingTraceRetreiveFailed,
} from "@faire/web-api--source/events/signin/timing/hcaptchaUserWait";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";

const trackPreFetchingToken = () => {
  trackSigninHcaptchaUserWaitTiming();
  trackSigninHcaptchaUserWaitTimingTraceDataRequested();
};

const trackPostFetchingToken = (data: ILoginRequest.IHCaptchaData) => {
  if (data.token) {
    trackSigninHcaptchaUserWaitTimingTraceDataRetrieved();
  } else {
    trackSigninHcaptchaUserWaitTimingTraceRetreiveFailed();
  }
};

export const Tracking = {
  start: trackPreFetchingToken,
  end: trackPostFetchingToken,
};
